export function lerp(s, e, t) {
  return round((1 - t) * s + t * e)
}

export function damp(x, y, lambda, dt) {
  return lerp(x, y, 1 - Math.exp(-lambda * dt))
}

export function clamp(val, min, max) {
  return round(Math.min(Math.max(min, val), max))
}

export function mapLinear( x, a1, a2, b1, b2 ) {
	return b1 + ( x - a1 ) * ( b2 - b1 ) / ( a2 - a1 );
}

export function mapTo(value, inMin, inMax, outMin, outMax, capped) {
  const newVal = ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin

  if (capped !== null && capped) {
    const max = outMin > outMax ? outMin : outMax
    const min = outMin > outMax ? outMax : outMin

    return clamp(newVal, min, max)
  }

  return round(newVal)
}

export function lineEq(y2, y1, x2, x1, currentVal) {
  const m = (y2 - y1) / (x2 - x1)
  const b = y1 - m * x1
  return m * currentVal + b
}

export function getRandomFloat(min, max) {
  return (Math.random() * (max - min) + min).toFixed(2)
}

export function round(number, precision = 4) {
  const factor = Math.pow(10, precision)
  return Math.round(number * factor) / factor
}

export function pad(number, pad = '000') {
  const str = '' + number
  return pad.substring(0, pad.length - str.length) + str
}

export function abs(num) {
  return Math.abs(num)
}

export function calcAngleDegrees(x, y) {
  return round(Math.atan2(y, x) * 180) / Math.PI
}

export function mapRange(inMin, inMax, outMin, outMax, value) {
  const inRange = inMax - inMin
  const outRange = outMax - outMin
  return outMin + (((value - inMin) / inRange) * outRange || 0)
}

export function normalize(min, max, value) {
  return mapRange(min, max, 0, 1, value)
}
